import { Div, Button } from '@codesuma/baseline'
import catalog from '../../services/country-occasions'
import { CatalogCountry, CatalogOccasion, CatalogOccurrence, OccasionType } from '../../services/occasion-catalog'
import { G_MONTHS, G_MONTHS_EN } from '../../configs/names'
import { toFaDigits } from '../../helpers/digits'
import { ruleText } from './rule-text'
import { regionText } from './region-text'
import style from './index.module.css'

const TYPE_LABELS: Record<OccasionType, string> = {
    public_holiday: 'تعطیل رسمی',
    named_in_law: 'در قانون آمده، تعطیل نیست',
    commemorative: 'روز بزرگداشت',
}

const PLUS_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M11 5h2v14h-2z"/><path d="M5 11h14v2H5z"/></svg>'
const CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 13l4 4L19 7"/></svg>'

const enDate = (iso: string) => {
    const [, month, day] = iso.split('-').map(Number)
    return `${day} ${G_MONTHS_EN[month - 1].slice(0, 3)}`
}

const faDate = (iso: string) => {
    const [, month, day] = iso.split('-').map(Number)
    return `${toFaDigits(day)} ${G_MONTHS[month - 1]}`
}

export const OccasionRow = (
    occasion: CatalogOccasion,
    occurrence: CatalogOccurrence,
    country: CatalogCountry,
    allIds: string[],
    byId: Map<string, CatalogOccasion>,
    syncers: (() => void)[],
    picked: string[] | undefined,
) => {
    const row = Div()
    row.addClass(style.row)

    const line = (text: string | undefined, cls: string, into: ReturnType<typeof Div>) => {
        if (!text) return
        const el = Div(text)
        el.addClass(cls)
        el.attr('dir', 'auto')
        into.append(el)
    }

    const primary = Div()
    primary.addClass(style.primary)
    row.append(primary)
    line(enDate(occurrence.date), style.date, primary)

    const pick = Button()
    pick.addClass(style.pick)
    pick.on('click', () =>
        catalog.setShown(
            country.code, occasion.id, !catalog.shows(country.code, occasion), allIds, picked))
    syncers.push(() => {
        const on = catalog.shows(country.code, occasion)
        pick.html(on ? CHECK_SVG : PLUS_SVG)
        pick.toggleClass(style.picked, on)
        pick.attr('aria-label',
            `${on ? 'حذف' : 'افزودن'} ${occasion.names.fa ?? occasion.names.en}`)
    })
    primary.append(pick)

    const secondary = Div()
    secondary.addClass(style.secondary)
    row.append(secondary)
    line(occasion.names.fa, style.translated, secondary)
    line(occasion.names.local ?? occasion.names.en, style.original, secondary)
    // The list runs in date order with no headings above it, so every row says
    // where it applies.
    line(`${TYPE_LABELS[occasion.type]} · ${regionText(occasion, country, picked)}`,
        style.meta, secondary)
    line(ruleText(occasion.dateRule, byId), style.rule, secondary)
    line(occurrence.observedDate && `تعطیلی رسمی: ${faDate(occurrence.observedDate)}`,
        style.observed, secondary)
    line(occasion.applicability?.note.fa, style.note, secondary)

    return row
}
